import * as React from "react";
import LodgingImagesViewer, { LodgingImagesViewerDisplayMode } from "./LodgingImagesViewer";

import "./LodgingImages.scss";
import { LodgingPresentationQuery } from "./operations.generated";
import { LodgingPageTranslations } from "./translations/LodgingPageTranslations";
import Breadcrumb, { BreadcrumbItem } from "./Breadcrumb";
import FavoriteButton from "./FavoriteButton";
import { FavouritesTranslations } from "./translations/FavouritesTranslations";

interface Props {
    clusterImageTagId: number;
    floorPlanImageTagId: number;
    displayMode?: LodgingImagesViewerDisplayMode; 
    useGrouping: boolean;
    translations: LodgingPageTranslations;
    favouritesTranslations: FavouritesTranslations;
    breadcrumb: BreadcrumbItem[];
    favorite: boolean;
    onFavoriteChanged: (value: boolean) => void;
}

export default function LodgingImages({
    images,
    useGrouping,
    clusterImageTagId,
    floorPlanImageTagId,
    displayMode,
    translations,
    favouritesTranslations,
    activeDescription,
    breadcrumb,
    favorite,
    onFavoriteChanged,
}: Props & LodgingPresentationQuery["lodgingPresentation"]["lodging"]) {
    return (
        <>
            <div className="bwp-lodging-images__head">
                <Breadcrumb items={[...breadcrumb]} />
                <FavoriteButton
                    value={favorite}
                    onChange={onFavoriteChanged}
                    text={favorite ? favouritesTranslations.removeFromFavourites : favouritesTranslations.addToFavourites}
                />
            </div>
            <LodgingImagesViewer
                isGrouped={useGrouping}
                images={images}
                clusterImageTagId={clusterImageTagId}
                floorPlanImageTagId={floorPlanImageTagId}
                displayMode={displayMode}
                translations={translations}
                embeddedVideoHtml={activeDescription?.embeddedVideoHtml}
            />
        </>
    );
}
